import i18n from '@atpoint/atpjs/helpers/i18n'
import { Component } from 'react'
import { P } from 'swisscard/components/typography'

import type { ErrorInfo } from 'react'

interface Error {
  stack?: string
}

class ErrorBoundary extends Component {
  state = {
    hasError: false,
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(error, errorInfo)
  }

  render() {
    const { hasError } = this.state
    if (hasError) {
      return (
        <P size="small" variant="error">
          {i18n.trans(['errors', 'boundaryError'])}
        </P>
      )
    } else {
      return this.props.children
    }
  }
}

export default ErrorBoundary
